import React, { useState } from 'react';
import { getHeaderValue } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
/**
 *
 * PDF Previewer - Accepts an url to feed in react-pdf package
 * handles pdf paging
 * @param {string} url
 * @public
 */

function SuperPdfViewer({ url, hideToolbar, token }) {
  const renderToolbar = (Toolbar) => (
    <>
      <Toolbar />
      <div className="fx actr cp">
        <SVGIcon name="Close" color="white" />
      </div>
    </>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar
  });

  return (
    <>
      <Worker
        // workerUrl={location.origin + location.pathname + 'pdf.worker.min.js'}
        workerUrl="https://assets.superops.ai/workers/pdf.worker.min.js" //Current version @3.11.174 this worker version should match with pdfjs-dist version
      >
        <Viewer
          fileUrl={url}
          plugins={hideToolbar ? [] : [defaultLayoutPluginInstance]}
          withCredentials
          httpHeaders={
            token
              ? {
                  ...getHeaderValue(),
                  Authorization: `Bearer nl-${token}`
                }
              : undefined
          }
        />
      </Worker>
    </>
  );
}

export default SuperPdfViewer;
